import React, { ReactNode } from "react"
import { Box } from "@mui/material"

export default function Harmonization({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        // px: 2.5,
        py: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100%",
        width: "100%",
      }}
    >
      {children}
    </Box>
  )
}
